import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  NgModule,
  NO_ERRORS_SCHEMA,
  Output,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpService } from 'src/app/services/http/http.service';
import { AutonumericDirective } from "@dealpos-npm/ng-dealpos-library/directives/autonumeric";

@Component({
    selector: 'POS-complex-pagination',
    templateUrl: './complex-pagination.component.html',
    styleUrls: ['./complex-pagination.component.scss'],
    standalone: false
})
export class ComplexPaginationComponent {
  /**
   * Indicates whether the page number can be edited.
   */
  @Input() editPageNumber = true;
  @Input() pageData: any;
  @Input() total: any;
  @Input() api: string;
  @Input() nextButtonAlwaysVisible = false;
  @Output() jumpToPage = new EventEmitter();
  @Output() previousPage = new EventEmitter();
  @Output() nextPage = new EventEmitter();
  pageNumber = 1;
  showingNumber = this.pageNumber;
  listTotal = -1;
  constructor(private httpService: HttpService) {}

  onJumpToPage(event: any): void {
    if (event.key === 'Enter') {
      this.pageData.PageNumber = this.pageNumber;
      this.showingNumber = this.pageNumber;
      this.jumpToPage.emit(this.pageNumber);
    }
  }
  onPreviousPage(): void {
    this.pageData.PageNumber -= 1;
    this.pageNumber = this.pageData.PageNumber;
    this.showingNumber = this.pageNumber;
    this.previousPage.emit(this.pageNumber);
  }
  onNextPage(): void {
    this.pageData.PageNumber += 1;
    this.pageNumber = this.pageData.PageNumber;
    this.showingNumber = this.pageNumber;
    this.nextPage.emit(this.pageNumber);
  }

  public StoreRowsCountAPIResult(): void {
    this.httpService.get<any>('/api/' + this.api).subscribe((data) => {
      this.listTotal = data.Count ? data.Count : data;
      this.pageData.HideStoreApiCount = true;
    });
  }
}

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, AutonumericDirective],
  declarations: [ComplexPaginationComponent],
  exports: [ComplexPaginationComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class ComplexPaginationModule {}
